// window.Drupal.settings.sante_apf only for find page

export default {
  questionnaire: {
    labels: window?.drupalSettings?.sante_apf?.labels,
    languages: window?.drupalSettings?.sante_apf?.languages,
  },
};
